import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAssetPath } from '../../utils/assetHelper';
import './SidebarMenu.scss';

/**
 * SidebarMenu component
 * 
 * Renders the side navigation menu exactly as in the original HTML/CSS design.
 */
const SidebarMenu: React.FC = () => {
  const location = useLocation();
  
  return (
    <div className="c-sidebar-menu">
      <ul>
        <li className={location.pathname === '/' ? 'selected' : ''}>
          <Link to="/" title="Dashboard">
            <img src={getAssetPath('assets/images/s-m-dashboard.svg')} alt="Dashboard" />
          </Link>
        </li>
        <li className={location.pathname.includes('/wallet') ? 'selected' : ''}>
          <Link to="/wallet-finance" title="Wallet">
            <img src={getAssetPath('assets/images/s-m-wallet.svg')} alt="Wallet" />
          </Link>
        </li>
        <li>
          <Link to="#" title="Store">
            <img src={getAssetPath('assets/images/s-m-store.svg')} alt="Store" />
          </Link>
        </li>
        <li className={location.pathname.includes('/settings') ? 'selected' : ''}>
          <Link to="/settings-profile" title="Settings">
            <img src={getAssetPath('assets/images/s-m-settings.svg')} alt="Settings" />
          </Link>
        </li>
        <li>
          <Link to="#" title="Help">
            <img src={getAssetPath('assets/images/s-m-help.svg')} alt="Help" />
          </Link>
        </li>
        <li className="notifications">
          <Link to="#" title="Notifications">
            <i className="bi bi-bell-fill"></i>
          </Link>
        </li>
        <li className="logout">
          <Link to="#" title="Logout">
            <img src={getAssetPath('assets/images/s-m-logout.svg')} alt="Logout" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SidebarMenu; 